import Alerts from 'lib/alerts';
import template from 'commons/templates/calendar/Calendar.ejs';
import birthdayTemplate from 'commons/templates/calendar/Birthday.ejs';
import eventTooltip from 'commons/templates/calendar/Event.ejs';
import LeaveRequestModal from 'commons/views/LeaveRequestModal';
import ActionLogView from 'commons/views/ActionLog';
import CalendarListView from 'commons/views/calendar/CalendarList';
import CalendarHelper from 'helpers/calendar';
import Attachments from 'newCollections/attachments';
import LeaveRequests from 'newCollections/leave-requests';
import Holidays from 'newCollections/holidays';
import LeaveRequest,
{statuses as LeaveRequestStatuses} from 'newModels/leave-request';
import Loader from 'helpers/loader';
import moment from 'moment';

// for reference: https://github.com/fullcalendar/fullcalendar/tree/9aa9e4400ac72d53362706927ac3c902c8544032
require('fullcalendar');

module.exports = Backbone.View.extend({
    leaveEvents: null,
    leaveRequestModal: null,
    selectedRegions: [],

    events: {
        'change .js-location-select':   'changeLocation',
        'change .js-status-select':     'changeStatus',
        'change .js-display-radio':     'changeDisplay'
    },

    initialize: function(options) {
        this.options = Object.assign({
            statuses: LeaveRequestStatuses,
            template: template,
            templateExtra: {}
        }, options || {});
        this.locations = options.locations;
        this.location          = app.user.isEmployee() ?
            app.employee.get('companyLocationId') : null;
        this.holidays          = this.location ? options.holidays
            .filter(({_enabled}) => _enabled) : options.holidays;
        this.status            = null;
        this.display           = '1';
        this.month             = null;
        this.leaveRequestModal = new LeaveRequestModal();
        this.leaveRequestModal.on('update', function() {
            if (this.$('.js-calendar.hidden-xs')) {
                // means that actionLog is in display instead of calendar
                this.render(this.options);
            } else {
                // 20200429 set location to null before another refetch of
                // calendar data refetch (note that the leave requests don't get
                // re-fetched)
                this.location = null;
                this.$calendar.fullCalendar('refetchEvents');
            }
        }.bind(this));
    },

    render: function(options) {
        var id = options.id;
        var action = options.action;
        var date = options.date;
        this.$el.html(template(this.options));

        this.$('.js-location-select').chosen({
            width: '160px'
        });

        this.$calendar = this.$('.js-calendar');
        this.initCalendar();

        if (id && action) {
            this.calendarAction(id, action);
        } else if (date) {
            this.$calendar.fullCalendar('gotoDate', date);
        }

        if (this.options.employees.length > 0) {
            this.calendarListEvents();
        }

        if (this.options.collection) {
            this.actionLog = new ActionLogView({
                collection: this.options.collection,
                fetchMore: this.options.fetchMore,
                layerMap: this.options.layerMap
            });
            this.$('.js-action-log').html(this.actionLog.render().el);
        }

        this.$(`.js-display-radio[value="${this.display}"]`)
            .parent().addClass('active');

        return this;
    },

    initCalendar() {
        //this.$calendar.fullCalendar('destroy');
        this.$('.js-loader').show();
        this.$calendar.fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: ''
            },
            timezone: 'UTC',
            aspectRatio: 2.5,
            eventLimit: 4,
            displayEventTime: false,
            eventRender: this.calendarEventRender.bind(this),
            eventAfterRender: this.calendarEventAfterRender.bind(this),
            dayRender: this.calendarDayRender.bind(this),
            dayClick: this.calendarDayClick.bind(this),
            eventClick: this.calendarEventClick.bind(this),
            eventMouseover: this.calendarEventMouseover,
            events: this.calendarEvents.bind(this),
            loading: function(isLoading) {
                // Don't show loader if there are
                // no employees assigned to location
                if (isLoading && this.options.employees.length > 0) {
                    this.$('.js-loader').show();
                } else {
                    this.$('.js-loader').hide();
                }
            }.bind(this)
        });
    },

    changeLocation: function(e) {
        new Holidays(null, {location: e.target.value, companyId: app.company})
            .fetch()
            .then((holidays) => {
                this.location = e.target.value;
                this.holidays = this.location ?
                    holidays.filter(({_enabled}) => _enabled) :
                    holidays;
                this.$calendar.fullCalendar('prev');
                this.$calendar.fullCalendar('next');
            });

    },

    changeStatus: function(e) {
        this.status = parseInt(e.target.value);
        this.$calendar.fullCalendar('refetchEvents');
        //this.initCalendar();
    },

    changeDisplay: function(e) {
        this.display = e.target.value;
        this.$('.js-display-radio').each(() => {
            $(this).parent().removeClass('active');
        });
        this.$(e.target).toggleClass('active');
        this.$('.js-calendar-list').removeClass('hidden');

        if (this.display === '2') {
            this.$('.js-calendar .fc-view-container').hide();
            this.$('.js-calendar .fc-view-container').addClass('hidden');
        } else {
            this.$('.js-calendar .fc-view-container').show();
            this.$('.js-calendar .fc-view-container').removeClass('hidden');
            this.$('.js-calendar-list').addClass('hidden');
        }
    },

    calendarListEvents: function() {
        this.month = moment(this.$calendar.fullCalendar('getDate'));
        LeaveRequests.fetchForCalendar({
            employees: this.options.employees,
            start: this.month.startOf('month').toDate(),
            end: this.month.endOf('month').toDate(),
            status: this.status,
            location: this.location
        }).then(leaveRequests => {
            this.calendarList = new CalendarListView({
                leaveRequests
            });
            this.$('.js-calendar-list').html(this.calendarList.render().el);
        });
    },

    calendarEvents: function(start, end, timezone, callback) {
        if (this.options.employees.length === 0) {
            return callback || function() {};
        }

        this.calendarListEvents();
        return LeaveRequests.fetchForCalendar({
            employees: this.options.employees,
            start: start,
            end: end,
            status: this.status,
            location: this.location
        }).then(leaveRequests => {
            callback(leaveRequests.asCalendarEvents());
        });
    },

    calendarAction: function(id, action) {
        const leaveRequest = new LeaveRequest({objectId: id});

        return leaveRequest.fetch()
            .then(() => leaveRequest.fetchType())
            .then(() => leaveRequest.fetchEmployee())
            .then(emp => {
                if (!emp || !leaveRequest.getType()) {
                    return Promise.reject(
                        `Couldn't fetch data from server`
                    );
                }

                return emp.fetchLeaveApprovals();
            })
            .then(() => {
                this.calendarEventClick({model: leaveRequest});
                setTimeout(() => {
                    switch (action) {
                        case 'reject':
                            this.leaveRequestModal.$('.js-reject').click();
                            break;
                        case 'approve':
                            this.leaveRequestModal.$('.js-approve').click();
                            break;
                    }
                    this.$calendar.fullCalendar(
                        'gotoDate',
                        moment(leaveRequest.get('dateFrom'))
                    );
                }, 1000);
                return true;
            })
            .catch(err => { Alerts.show('criticalError', err); });
    },

    calendarDayClick: function(date, ev) {
        $(ev.target).tooltip('hide');
        app.mainRouter.navigate('#calendar/add/' +
            date.format('DD-MM-YYYY'), {trigger: true});
    },

    calendarEventClick: function(event) {
        const stopLoader = Loader.startFullPage('.tab-content');
        const leaveRequest = event.model;

        leaveRequest.userEmployee = this.options.userEmployee;
        leaveRequest.attachments = new Attachments(
            null, {attachable: leaveRequest}
        );

        return leaveRequest.canBeCancelled()
            .then(response => {
                leaveRequest.isCancellable = response;
            })
            .then(() => leaveRequest.attachments.fetch())
            .then(() => {
                this.leaveRequestModal.setModel(leaveRequest).render().show();
            })
            .finally(() => stopLoader());
    },

    // Fix tooltip zindex issue
    calendarEventMouseover: function() {
        $(this).closest('.fc-day-grid').find('.fc-row').css({'zIndex': 1});
        $(this).closest('.fc-row').css({'zIndex': 2});
    },

    updateEvents: function() {
        this.leaveEvents = this.collection.asCalendarEvents();
        this.$calendar.fullCalendar('rerenderEvents');
    },

    calendarEventRender: function(event, $el, view) {
        const leaveRequest = event.model;
        const leaveRequestData = leaveRequest.asCalendarEvent();
        const type = leaveRequest.getType();
        const $content = $el.find('.fc-content');
        $content
            .attr('data-employee', leaveRequest.getEmployee().get('fullName'))
            .attr('data-dateFrom', leaveRequestData.start.format('YYYY-MM-DD'))
            .attr('data-dateTo', leaveRequestData.end.format('YYYY-MM-DD'))
            .attr('data-leaveType', type.get('name'))
            .attr('data-status', leaveRequest.getStatusText());
        const $employee = $('<strong>')
            .addClass('fc-title')
            .append(leaveRequest.getEmployee().get('fullName'));

        if (leaveRequest.isCancelled()) {
            return false;
        }

        if (view.isEventsRendered) {
            this.calendarFixHalfEvent(event, $el, view, '50%');
            this.calendarEventAfterRender(event, $el)
        }

        $content.html('').append($employee).append(' ' + type.get('name'));
        if (
            type.get('color') &&
            !leaveRequest.isAwaiting() &&
            !leaveRequest.isRejected()
        ) {
            $el.css({backgroundColor: type.get('color')});
        }

        $el.toggleClass('event-leave-awaiting', leaveRequest.isAwaiting());
        $el.toggleClass('event-leave-rejected', leaveRequest.isRejected());
        return $el;
    },

    calendarEventAfterRender: function(event, $el) {
        const firstRow = $el.closest('.fc-row').is(':first-child');

        $el.attr('data-toggle', 'tooltip').tooltip({
            title: eventTooltip({
                leaveRequest: event.model,
                leaveType: event.model.getType()
            }),
            placement: firstRow ? 'bottom' : 'top',
            html:      true,
            trigger:   'hover',
            delay:     {hide: 2000}
        });

        this.calendarFixHalfEvent.apply(this, arguments);
    },

    calendarDayRender: function(date, cell) {
        const location = this.location ?
            this.locations.find(({id}) => id === this.location) : null;
        const workload = CalendarHelper.getDayWorkLoad(cell, location);

        if (workload === 0) {
            cell.addClass('day-off');
        } else if (workload === 0.5) {
            cell.addClass('half-day');
        }

        CalendarHelper.renderHoliday(
            this.holidays,
            date,
            cell
        );

        this.calendarBirthdaysRender(date, cell);
    },

    calendarBirthdaysRender: function(date, cell) {
        if (!app.company.get('showBirthdaysInCalendar')) {
            return false;
        }

        var employees = this.options.employees.filter(function(employee) {
            return (
                moment(employee.get('dob')).format('MMDD') ===
                    moment(date).format('MMDD')
            );
        });
        var $tooltip;

        const activeEmployees = employees.filter(emp => emp.get('hiddenAt') === null || emp.get('hiddenAt') === undefined);
        if (activeEmployees.length === 0) {
            return;
        }
        $tooltip = birthdayTemplate({
            header: activeEmployees.length === 1 ? 'Birthday' : 'Birthdays',
            description: _.map(activeEmployees, function(employee) {
                return employee.get('fullName');
            }).join(', ')
        });

        this.$(cell).append($tooltip).find('[data-toggle=tooltip]').tooltip();
    },

    calendarFixHalfEvent: function(event, $el, view, offset) {
        var leaveRequest = event.model;

        if (!offset) {
            offset = (50 / ($el.parent().attr('colspan') || 1)) + '%';
        }

        if (
            leaveRequest.dateFromIsMorning() &&
                !leaveRequest.get('dateTo') &&
                $el.hasClass('fc-start')
        ) {
            $el.css('margin-right', offset);
        }

        if (leaveRequest.dateFromIsAfternoon() && $el.hasClass('fc-start')) {
            $el.css('margin-left', offset);
        }

        if (leaveRequest.dateToIsMorning() && $el.hasClass('fc-end')) {
            $el.css('margin-right', offset);
        }
    },

    remove: function() {
        this.leaveRequestModal.remove();
        this.undelegateEvents();
        return Backbone.View.prototype.remove.apply(this, arguments);
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/calendar/Calendar.js